import { TrvCryptoService } from "./TrvCryptoService";

export class TickerService {
  private static currencies: Promise<Currency[]>;

  private static async fetchData(): Promise<Currency[]> {
    const data = await TrvCryptoService.getTicker();

    return data.map(t => ({
      name: t.name,
      code: t.symbol,
      sellPrice: t.price,
      variation: t.priceChange24hPercent,
      volume: t.volume,
      low: t.low,
      high: t.high,
      marketcap: t.marketcap,
      icon: t.icon,
      lastUpdateTimestamp: t.lastUpdateTimestamp
    }));
  }

  static async get(): Promise<Currency[]> {
    if (this.currencies === undefined) {
      this.currencies = this.fetchData();
    }

    return this.currencies
  }
}
